// extracted by mini-css-extract-plugin
export default {"waitStyle":"saveBtn_waitStyle__LqjIG","doneText":"saveBtn_doneText__zG3FH","saveText":"saveBtn_saveText__w0Yl1"};